<template>
  <div class="text-options-data-dialog">
    <el-collapse v-model="activeNames">
      <el-collapse-item @mousedown.native="collapseMouseDown($event, '1')" title="数据源" name="1">
        <div>
          <div  class="data-source-type mb12">
            <cx-slider :value.sync="noCacheComponent" :options="dataOptions" :height="32" />
          </div>
          <div v-show="pageType !== 'detailPage' && pageType !== 'listPage' && noCacheComponent && !noCacheComponentLayout" class="mb12">
            <!-- <div class="dataSource-item mt12" @click="goToChooseData">
              <span>进入数据管理后台 </span>
            </div> -->
            <data-center-choose
                :checkStatus="checkStatus"
                :myId="ids"
                :options="options"
                @onDataCenterChange="onDataCenterChange"
            />
            <auto-update-timer class="mt12" :isLocal="!(pageType !== 'detailPage' && pageType !== 'listPage' && noCacheComponent && !noCacheComponentLayout)"/>
          </div>
          <div v-show="!noCacheComponent">
            <el-input
                type="text"
                class="mb8"
                v-model="iframeUrl"
                placeholder="请输入http://或https://开头的地址"
            ></el-input>
            <el-checkbox-group v-model="accessRulers">
              <el-checkbox label="传递门户参数">携带系统参数</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
          v-if="(showColsFieldMapping && (noCacheComponentLayout ) && noCacheComponent) || (!noCacheComponentLayout && pageType === 'detailPage' && noCacheComponent)"
          @mousedown.native="collapseMouseDown($event, '2')"
          title="数据绑定"
          name="2"
      >
        <div v-if="showColsFieldMapping && (noCacheComponentLayout  || noCacheComponent)" class="content">
          <colsFieldMappingSetting :ids="ids" :options="options" v-if="showColsFieldMapping"></colsFieldMappingSetting>
        </div>
        <detailPageFieldMappingSetting v-else :myid="ids" :options="options"></detailPageFieldMappingSetting>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import colsFieldMappingSetting from "publicSetting/colsFieldMappingSetting.vue";
import dataCenterChoose from "publicSetting/dataCenterChoose.vue";
import detailPageFieldMappingSetting from "publicSetting/detailPageFieldMappingSetting.vue";
import autoUpdateTimer from "toolbarComponents/utilsComponents/autoUpdateTimer/autoUpdateTimer.vue";
import listPageFieldMappingSetting from "publicSetting/listPageFieldMappingSetting.vue";
import {isExist} from "utils";
import dataToolMixin from "materials/dataToolMixin"

export default {
  name: "iframe-options-data" ,
  components: {
    listPageFieldMappingSetting,
    autoUpdateTimer,
    detailPageFieldMappingSetting,
    dataCenterChoose,
    colsFieldMappingSetting
  },
  mixins: [dataToolMixin],
  props: {
    options: { type: Object },
    container_id: { type: [Number, String] },
    rect_id: { type: [Number, String] }
  },
  computed:{
    pageType() {
      return this.$store.state[this.request_prefix].type
    },
    ids() {
      return this.$store.state.states.activeID
    },
    dataOptions() {
      const options = [{ value: false, title: "本地数据" }]
      if (this.pageType === "detailPage" || this.showColsFieldMapping) {
        options.push({ value: true, title: "数据绑定" })
      } else if((this.isBigScreen && !this.noCacheComponentLayout) || (!this.isBigScreen && !this.showColsFieldMapping)) {
        options.push({ value: true, title: "数据中心" })
      }
      return options
    },
    checkStatus() {
      return this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids)
    },
    isBigScreen() {
      if (this.request_prefix == "bigScreen") {
        return true
      } else {
        return false
      }
    },
    iframeUrl: {
      get() {
        return this.options.iframeUrl
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iframeUrl", false)
      }
    },
    showColsFieldMapping() {
      return this.ids?.uid || isExist(this.ids?.elementInSwiperId) || this.dataIds?.elementInDataGridId
    },
    noCacheComponent: {
      get() {
        return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "noCacheComponent", false, null)
        // 如果在详情页中文本组件选中外接数据源，需要先初始化文本组件在详情页的相关对象属性detailFieldMapping，同时给文本组件增加在详情页中请求数据源的插件
        // 切换到本都数据的时候，清除之前绑定的appId
        if (!newVal) {
          this.$changeOptionsEV("", "appId", false, false, false, true)
        }
        if (this.pageType === "detailPage" && newVal) {
          this.$changeOptionsEV(
              {
                isChecked: false,
                dataType: "dataKey",
                fieldFlag: ""
              },
              "detailFieldMapping",
              false,
              false,
              false,
              true
          )
        }
      }
    },
    accessRulers: {
      get() {
        return this.options.accessRulers ? this.options.accessRulers : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "accessRulers", false)
      }
    },
  },
  data(){
    return {
      activeNames: ["1", "2", "3"]
    }
  },
  methods:{
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    goToChooseData() {
      if (this.fetchEnd) return
      this.fetchEnd = true
      const { websiteId, pageId, sign, wfwfid, homePageId, pageType } = this.$store.state.states.getDataPageIds
      const rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids)
      let { moduleId, appId } = rectAttr
      if (moduleId === undefined) moduleId = rectAttr?.options?.moduleId
      if (appId === undefined) appId = rectAttr?.options?.appId
      if (!!!moduleId || !!!appId) {
        this.$saveModule(this.ids, "31CB73E03E24BBFF", "临时")
            .then(res => {
              this.fetchEnd = false
              if (!!res.appId) {
                window.open(`/engine2/data/api-v2/admin/general/${res.appId}?w=${websiteId}&p=${pageId}&init=1`)
              }
            })
            .catch(err => (this.fetchEnd = false))
      }
      this.fetchEnd = false
      if (!!appId) window.open(`/engine2/data/api-v2/admin/general/${appId}?w=${websiteId}&p=${pageId}`)
    },
    async getBaseModuleDataLoop() {
      if (!this.checkStatus) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "error",
          message: "请进入数据管理后台添加数据"
        })
        return
      }
      this.updateNormalRect
          .call(this, datas => {
            if (datas.length === 0) {
              if (this.emptyDataShowLocal) {
                this.imgSrc = this.emptyImgSrc
              }
              this.$changeOptionsEV(true, "isEmptyData", false, null, this.ids, true)
            } else {
              this.$changeOptionsEV(false, "isEmptyData", false, null, this.ids, true)
              this.imgSrc = datas[0][Object.keys(datas[0])[0]].value
            }
          })
          .then(restDataUrl => {
            this.restDataUrl = restDataUrl
          })
    },
    onDataCenterChange() {
      if(!this.showColsFieldMapping || !this.noCacheComponentLayout) {
        this.getBaseModuleDataLoop()
      }
    },
    updateToolbarData() {
      if(!this.showColsFieldMapping || !this.noCacheComponentLayout) {
        this.getBaseModuleDataLoop()
      }
    }
  }
}
</script>

<style scoped>
.left-label {
  min-width: 60px;
}
.card {
  background: rgba(41, 44, 49, 1);
}
.count-limit-item/deep/ .el-input__inner {
  background: #35383f;
  padding: 0 12px;
  border-radius: 4px;
}

.setting-item .count-limit-item span {
  margin: 0 8px;
}
.setting-item .content-item .el-checkbox {
  margin-right: 20px;
}
.count-limit-item /deep/ .el-radio {
  margin-top: 7px;
  margin-bottom: 3px;
}

.count-limit-item /deep/ .el-radio:first-child {
  margin-top: 0;
}

.count-limit-item /deep/ .el-radio-group {
  width: 80px;
}
.getDataBtn {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 6px 0px;
}
.getDataBtn:hover {
  cursor: pointer;
}
.dataSource-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dataSource-item .link {
  color: var(--themeColor);
  cursor: pointer;
}
.dataUrl-item input {
  width: 252px;
  height: 32px;
  background: #35383f;
  color: rgba(255, 255, 255, 0.2);
}
.dataUrl-item .tips {
  color: var(--fourthTextColor);
}
.video-bgcard {
  display: inline-block;
  vertical-align: top;
  width: 140px;
  height: 90px;
  border: 1px solid #e9e9e9;
  box-sizing: border-box;
  border-radius: 4px;
  background: url("../../../assets/images/image_placeholder.png") no-repeat center center;
}

.video-upload-box {
  display: inline-block;
  vertical-align: top;
  margin-left: 16px;
  width: calc(100% - 156px);
}
.tips {
  margin-bottom: 26px;
  font-size: 12px;
  line-height: 17px;
}

.video-upload-box ::v-deep .el-upload--picture-card {
  width: 80px;
  height: 28px;
  line-height: 28px;
  border: none;
  background: none;
}
.video-upload-btn {
  width: 80px;
  height: 28px;
  border: 1px solid #3d82f2;
  box-sizing: border-box;
  border-radius: 4px;
  color: #3d82f2;
  font-size: 14px;
  line-height: 20px;
  background: transparent;
}
.video-source-box {
  margin-top: 8px;
}

.video-upload-ipt {
  margin-top: 8px;
}
</style>
